import React from 'react';
import { Popover } from '@mui/material';
import bem from 'utils/bem.js';
import Text from 'components/Text/index.js';
import Icon from 'components/Icon/index.js';
import './index.sass';

const { block, el } = bem('media-device-popover');
export const MediaDevicePopover = ({children, open, handleClose, anchorEl, container}) => {
    return (
        <Popover
            className={block()}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            container={container}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'left',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
        >
            <div className={el('body')}>
                <div className={ el('header') }>
                    <div className={ el('title') }>
                        <Text serif>Настройки</Text>
                    </div>
                    <Icon name={'x'} onClick={handleClose} />
                </div>
                <div className={el('content')}>
                    { children }
                </div>
            </div>
        </Popover>
    )
}
